import React, { useState } from 'react';
import styled from 'styled-components';
import { MuiTelInput, type MuiTelInputProps } from 'mui-tel-input';

export type PhoneInputFieldProps = MuiTelInputProps & {
  error?: boolean;
  helperText?: React.ReactNode;
};

export const PhoneInputField: React.FunctionComponent<PhoneInputFieldProps> = (
  props: PhoneInputFieldProps,
) => {
  const { error, helperText, disabled = false, value, size, ...rest } = props;
  const [isFocus, setIsFocus] = useState(false);
  const handleFocus = (): void => {
    setIsFocus(!isFocus);
  };
  return (
    <StyledPhoneInputField
      $error={error}
      $focus={isFocus}
      $disabled={disabled}
      aria-disabled={disabled}
      onFocus={handleFocus}
      onBlur={handleFocus}
    >
      <MuiTelInput
        className="styled-phone-input"
        {...rest}
        value={
          typeof value === 'string'
            ? (value[0] && value[0] === '+' ? '' : '+') + value
            : '+852'
        }
        disabled={disabled}
        error={error}
        size={size}
      />
      {error && (
        <div
          style={{ color: '#d32f2f', fontSize: '0.8rem', marginLeft: '1rem' }}
        >
          {helperText}
        </div>
      )}
    </StyledPhoneInputField>
  );
};

const StyledPhoneInputField = styled.div<{
  $error?: boolean;
  $focus: boolean;
  $disabled: boolean;
}>`
  width: 100%;
  display: flex;
  flex-direction: column;

  label {
    background: white;
    color: ${props =>
      props.$disabled
        ? 'rgba(0, 0, 0, 0.38)'
        : props.$error
          ? '#d32f2f'
          : props.$focus
            ? '#951D1D'
            : '#00000099'} !important;
  }
`;
